<template>
  <div class="row">
    <div class="col-12 modal-wrapper">
      <h5>Notas de {{this.username()}}</h5>
      <ul>
        <li style="color: white; cursor: pointer;" v-on:click="openNotesForm()">
          Criar nota
        </li>
        <li style="color: white; cursor: pointer;" v-for="note in noteCollection" v-on:click="selectNote(note)">
          {{note.title}}
        </li>
      </ul>
      <NotesForm v-bind:visible="notesFormVisible" v-bind:note="current_note" v-on:note-created="addNote" v-on:note-updated="updateNote" v-on:note-deleted="deleteNote" v-on:form-close="closeForm" />
    </div>
  </div>
</template>

<script>
import NotesForm from './NotesForm'

export default {
  name: 'Notes',
  components: { NotesForm },
  data: () => {
    return {
      notes: [],
      current_note: null,
      notesFormVisible: false
    }
  },
  computed: {
    noteCollection () {
      return this.notes
    }
  },
  methods: {
    username () {
      return this.$cookies.get('user_name')
    },
    addNote (note) {
      this.loadNotes()
    },
    updateNote (note) {
      this.loadNotes()
    },
    deleteNote (note_id) {
      this.notes.splice(this.notes.findIndex(el => el.id === note_id), 1)
      this.closeForm()
    },
    closeForm () {
      this.notesFormVisible = false
    },
    selectNote (note) {
      this.current_note = note
      this.notesFormVisible = true
    },
    openNotesForm () {
      this.current_note = null
      this.notesFormVisible = true
    },
    loadNotes () {
      let successCallback = (response) => {
        if (response.body.data) {
          this.notes = response.body.data
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/notes`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  mounted(){
    this.$root.$on('NOTE_CREATED', () => { this.loadNotes() })
    this.loadNotes()
  }
}
</script>

<style>
.modal-wrapper { position: relative; }
</style>



// WEBPACK FOOTER //
// src/components/Notes.vue